import PersonIcon from '@material-ui/icons/Person';
import UserList from './list';
import UserShow from './show';
import UserEdit from './edit';

export default {
    list: UserList,
    show: UserShow,
    edit: UserEdit,
    icon: PersonIcon
};